import { networkDetector } from '../services/networkDetector';
import type { Network } from '../types/blockchain.types';

interface NetworkSelectorProps {
  selectedNetwork: Network | null;
  onNetworkChange: (network: Network) => void;
  address: string;
}

export function NetworkSelector({ selectedNetwork, onNetworkChange, address }: NetworkSelectorProps) {
  const detection = networkDetector.detectAddress(address);
  const compatibleNetworks = detection.compatible_networks;

  if (compatibleNetworks.length <= 1) {
    return null;
  }

  return (
    <div className="flex items-center gap-3">
      <label htmlFor="network-selector" className="text-sm font-medium text-gray-700 dark:text-gray-300">
        Network:
      </label>
      <select
        id="network-selector"
        value={selectedNetwork?.id || ''}
        onChange={(e) => {
          const network = networkDetector.getNetworkById(e.target.value);
          if (network) {
            onNetworkChange(network);
          }
        }}
        className="px-3 py-2 border border-gray-300 dark:border-legal-600 bg-white dark:bg-legal-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent text-sm"
      >
        {compatibleNetworks.map((network) => (
          <option key={network.id} value={network.id}>
            {network.name} ({network.native_currency})
          </option>
        ))}
      </select>
      <span className="text-xs text-gray-500 dark:text-gray-400">
        {compatibleNetworks.length} compatible networks detected
      </span>
    </div>
  );
}
